import { render } from "./ExpensesCard.vue?vue&type=template&id=1ec7c1c3"
import script from "./ExpensesCard.vue?vue&type=script&lang=js"
export * from "./ExpensesCard.vue?vue&type=script&lang=js"

import "./ExpensesCard.vue?vue&type=style&index=0&id=1ec7c1c3&lang=scss"

import exportComponent from "/home/runner/work/dotter/dotter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__